import FrmSettings from '@/pages/settings/FrmSettings.vue';
import FrmSettingsSyncContracts from '@/pages/settings/FrmSettingsSyncContracts.vue';

export default [
  {
    path: '/settings/',
    component: FrmSettings,
  },
  {
    path: '/settings/syncContracts/',
    component: FrmSettingsSyncContracts,
  },
];
